import { dcpcApi } from './dcpcApi';

export const METEO_CODE_CONFINES = 'MeteoCodeConfines';

dcpcApi.enhanceEndpoints({ addTagTypes: [METEO_CODE_CONFINES] });

const meteoCodeConfinesApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    updateMeteocodeConfines: builder.mutation({
      query: ({ id, body }) => ({
        url: `meteocode-confines${id ? `/${id}` : ''}`,
        method: id ? 'PUT' : 'POST',
        body,
      }),
      invalidatesTags: [METEO_CODE_CONFINES],
    }),
  }),
});

export const {
  useUpdateMeteocodeConfinesMutation,
} = meteoCodeConfinesApi;
